import { useNavigate, useParams } from "react-router-dom"
import { useForm } from "react-hook-form"
import { useGetClientByIdQuery, usePutClientMutation } from "../../features/CallApi"
import LoadScreen from "../UI/LoadScreen";
import { Button, ButtonGroup, Card, CardBody, CardFooter, CardHeader } from "reactstrap";
import { useEffect } from "react";


export const ClientEdit = () => {

    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const navigate = useNavigate();
    const { id } = useParams();
    const { data, isLoading, refetch } = useGetClientByIdQuery(id)
    const [putClient, { isLoading: isPuting }] = usePutClientMutation()
    useEffect(() => { refetch() }, [])

    const putFormClient = (data) => {
        if (data.birthday == "") {
            data.birthday = null;
        }
        putClient(data).unwrap().then(
            () => {
                navigate("/admin/clients")
            }
        )

    }

    return (
        <form onSubmit={handleSubmit(putFormClient)}>
            <div className="container">
                {!isPuting || !isLoading ?
                    <div>
                        {data ?
                            <Card>
                                <CardHeader>
                                    <h3>Редактриование данных гостя</h3>
                                </CardHeader>
                                <CardBody>
                                    <div>
                                        <input {...register("id")} defaultValue={data.id} hidden />
                                        <div className="d-md-flex">
                                            <div className="flex-fill">
                                                <div className="d-md-flex mb-md-2">
                                                    <div className="form-floating mb-1 flex-fill">
                                                        <input defaultValue={data.lastName} type="text" className={`form-control ${errors?.lastName && "is-invalid"}`} id="lastName" placeholder="Фамилия"
                                                            {...register("lastName", { required: { value: true, message: "Фамилия обязательно для заполнения" } })} />
                                                        <label htmlFor="lastName">Имя</label>
                                                        <div>
                                                            {errors.firstName && <span span className='text-danger'>{errors.firstName?.message}</span>}
                                                        </div>
                                                    </div>
                                                    <div className="form-floating mb-1 flex-fill me-md-1 ms-md-1">
                                                        <input defaultValue={data.firstName} type="text" className={`form-control ${errors?.firstName && "is-invalid"}`} id="firstName" placeholder="Имя"
                                                            {...register("firstName", { required: { value: true, message: "Имя обязательно для заполнения" } })} />
                                                        <label htmlFor="firstName">Имя</label>
                                                        <div>
                                                            {errors.firstName && <span span className='text-danger'>{errors.firstName?.message}</span>}
                                                        </div>
                                                    </div>
                                                    <div className="form-floating mb-1 flex-fill">
                                                        <input defaultValue={data.patronymic} type="text" className={`form-control ${errors?.patronymic && "is-invalid"}`} id="patronymic" placeholder="Отчество"
                                                            {...register("patronymic")} />
                                                        <label htmlFor="patronymic">Имя</label>
                                                        <div>
                                                            {errors.firstName && <span span className='text-danger'>{errors.firstName?.message}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="d-md-flex mb-md-2">
                                                    <div className="form-floating mb-1 flex-fill">
                                                        <input defaultValue={data.email} className={`form-control ${errors?.email && "is-invalid"}`} id="email" type="email" placeholder="E-Mail"
                                                            {...register("email")} />
                                                        <label htmlFor="email">Имя</label>
                                                        <div>
                                                            {errors.email && <span span className='text-danger'>{errors.email?.message}</span>}
                                                        </div>
                                                    </div>
                                                    <div className="form-floating mb-1 flex-fill me-md-1 ms-md-1">
                                                        <input defaultValue={data.phone} type="text" className={`form-control ${errors?.firstName && "is-invalid"}`} id="phone" placeholder="Телефон"
                                                            {...register("phone", { required: { value: true, message: "Телефон обязательно для заполнения" } })} />
                                                        <label htmlFor="phone">Телефон</label>
                                                        <div>
                                                            {errors.firstName && <span span className='text-danger'>{errors.firstName?.message}</span>}
                                                        </div>
                                                    </div>
                                                    <div className="form-floating mb-1 flex-fill">
                                                        <input defaultValue={data.birthday} type="date" className={`form-control ${errors?.birthday && "is-invalid"}`} id="birthday" placeholder="Дата рождения"
                                                            {...register("birthday")} />
                                                        <label htmlFor="birthday">Имя</label>
                                                        <div>
                                                            {errors.firstName && <span span className='text-danger'>{errors.firstName?.message}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="d-md-flex mb-md-2">
                                                    <div className="form-floating mb-1 flex-fill">
                                                        <input defaultValue={data.seriesDoc} className={`form-control ${errors?.seriesDoc && "is-invalid"}`} id="seriesDoc" tepy="text" placeholder="Серия документа"
                                                            {...register("seriesDoc")} />
                                                        <label htmlFor="email">Серия документа</label>
                                                        <div>
                                                            {errors.seriesDoc && <span span className='text-danger'>{errors.seriesDoc?.message}</span>}
                                                        </div>
                                                    </div>
                                                    <div className="form-floating mb-1 flex-fill ms-md-1">
                                                        <input defaultValue={data.numberDoc} type="text" className={`form-control ${errors?.numberDoc && "is-invalid"}`} id="numberDoc" placeholder="Телефон"
                                                            {...register("numberDoc")} />
                                                        <label htmlFor="numberDoc">Номер документа</label>
                                                        <div>
                                                            {errors.firstName && <span span className='text-danger'>{errors.firstName?.message}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex-fill align-self-stretch ms-md-1">
                                                <div className="mb-md-2" style={{ height: "100%" }}>
                                                    <div className="form-floating" style={{ height: "94%" }}>
                                                        <textarea
                                                            {...register("requisites")}
                                                            className="form-control" placeholder="Реквизиты" id="requisites" style={{ height: "100%" }}></textarea>
                                                        <label htmlFor="requisites">Реквизиты</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </CardBody>
                                <CardFooter>
                                    <ButtonGroup className="mt-2 mb-2">
                                        <Button color="success">Сохранить</Button>
                                        <Button onClick={() => navigate("/admin/clients")} color="warning">Отмена</Button>
                                    </ButtonGroup>
                                </CardFooter>
                            </Card> :
                            <div></div>}
                    </div>
                    : <LoadScreen />
                }
            </div>
        </form>

    )

}